import { formatPrice } from '@utils/strings'
import { InventoryItem, InventorySort, Venue, inventorySort } from 'types/model'

export function translateInventorySort(key?: InventorySort) {
  switch (key) {
    case inventorySort.priceAscending:
      return 'price'
    case inventorySort.priceDescending:
      return '-price'
    case inventorySort.alphabetical:
      return undefined
    default:
      return 'price'
  }
}

export function formatInventoryPrice({
  inventory,
  venue,
  quantity = 1,
}: {
  inventory: InventoryItem
  venue: Venue
  quantity?: number | null
}) {
  if (inventory.type === 'PACKAGE')
    return formatPrice(inventory.price, {
      currency: venue.currencyCode,
      languageCode: venue.languageCode,
    })

  const { price } = inventory
  const taxValue = price * inventory.tax
  const tipValue = price * inventory.tip
  const feeValue = inventory.fees.reduce((acc, cur) => {
    return acc + (cur.type === 'FLAT' ? cur.amount : cur.amount * price)
  }, 0)

  const preProcessingFeeTotal = price + taxValue + tipValue + feeValue

  const processingFee = inventory.userPaysProcessing
    ? venue.ticketProcessingFee * preProcessingFeeTotal
    : 0

  const totalPrice = preProcessingFeeTotal + processingFee

  return formatPrice(totalPrice, {
    currency: venue.currencyCode,
    languageCode: venue.languageCode,
  })
}
